// @ts-ignore
import { BladeApi, Pane } from 'tweakpane';
// @ts-ignore
import * as EssentialsPlugin from '@tweakpane/plugin-essentials';
// @ts-ignore
import { BladeController, View } from '@tweakpane/core';

interface FPSGraph extends BladeApi<BladeController<View>> {
    begin(): void;

    end(): void;
}

import { BaseScene } from '@/ts/utils/webgl/core/baseScene';

const SELECTOR = 'data-webgl';

export type SceneLink = Record<string, typeof BaseScene>;

//Class that attach function, usable from components to initialize, destroy, reload 3D scene;
export class SceneLoader {
    public $targets: HTMLElement[] = Array.from(document.querySelectorAll(`[${SELECTOR}]`));
    private controllersMap: SceneLink = {};
    private controllers: Array<[Symbol | string, BaseScene]> = [];
    private fpsGraph: FPSGraph | undefined;
    private loopActive = false;

    constructor(controllersMap?: SceneLink) {
        this.controllersMap = controllersMap || {};
    }

    register(controller: SceneLink) {
        this.controllersMap = {
            ...this.controllersMap,
            ...controller,
        };
    }

    init() {
        let gui: Pane;
        let $gui: HTMLDivElement;

        if (this.$targets.length) {
            $gui = document.createElement('div');
            $gui.classList.add('tweak-pane');
            gui = new Pane({ container: $gui, title: 'Monitor' });
            gui.registerPlugin(EssentialsPlugin);
            this.fpsGraph = gui.addBlade({
                view: 'fpsgraph',
                label: 'fpsgraph',
            }) as FPSGraph;
        }

        this.$targets.forEach($el => {
            const attrs = $el.getAttribute(SELECTOR)?.split(',') || [];

            attrs.forEach(attr => {
                attr = attr.trim();
                if (attr in this.controllersMap) {
                    const instance = new this.controllersMap[attr]($el, { ctrl: gui, view: $gui });
                    void this.load(Symbol(), instance);
                }
            });
        });
    }

    async load(key: string | Symbol, controller: BaseScene) {
        void controller.loadAll();
        this.controllers.push([key, controller]);
    }

    async unload(key: string | Symbol) {
        const index = this.controllers.findIndex(([id]) => {
            return key === id;
        });

        if (index > -1 && this.controllers[index]) {
            const [, controller] = this.controllers[index];
            await controller.destroy();
            this.controllers.splice(index, 1);
        }
    }

    render() {
        const controllers = this.controllers;
        const that = this;

        const loop = function () {
            that.fpsGraph?.begin();

            controllers.forEach(([, controller]) => {
                controller.render();
            });

            that.fpsGraph?.end();
            requestAnimationFrame(loop);
        };

        if (!this.loopActive && controllers.length) {
            this.loopActive = true;
            loop();
        }
    }
}
